import type { Rhythm, RhythmEvery, RhythmSource } from '@/api/types';

export const everyOptions: readonly RhythmEvery[] = ['week', '2weeks', 'month'];
export const everyLabel: Record<RhythmEvery, string> = { week: 'Каждую неделю', '2weeks': 'Раз в две недели', month: 'Раз в месяц' };

export const sourceOptions: readonly RhythmSource[] = ['report', 'meeting', 'linear', 'manual'];
export const sourceLabel: Record<RhythmSource, string> = { report: 'По отчётам', meeting: 'По встречам', linear: 'Задачи Linear', manual: 'Вручную' };

/** The small grey line under a regular work: where «Было» and «Будет» come from. */
export function sourceNote(r: Pick<Rhythm, 'source' | 'label'>): string | null {
  switch (r.source) {
    case 'report':
      return 'по отчётам';
    case 'meeting':
      return 'по встречам';
    case 'linear':
      return r.label ? `задачи Linear: ${r.label}` : 'задачи Linear';
    case 'manual':
      return 'вручную';
    default:
      return null;
  }
}
